import { REQUEST_DOCUMENT_TOAST_FALLBACK } from '@data-access/documents/contants';
import { RequestDocumentResponse, RequestDocumentResult } from '../types';

/** Whether the server sent the detailed ERM-13223 payload rather than the legacy `"success"`. */
const isDetailedResponse = (
  response: RequestDocumentResult,
): response is RequestDocumentResponse =>
  typeof response === 'object' &&
  response !== null &&
  typeof response.document_type_name === 'string';

/**
 * Request document toast message generator. Returns a fallback message if the server response is not detailed.
 */
export const getRequestDocumentToastMessage = (
  response: RequestDocumentResult,
): string => {
  if (!isDetailedResponse(response)) {
    return REQUEST_DOCUMENT_TOAST_FALLBACK;
  }

  const documentType = response.document_type_name;
  const hubSentence = "It's now a to-do in their collaboration hub.";

  return response.assignee_name
    ? `We asked ${response.assignee_name} for the ${documentType}. ${hubSentence}`
    : `We requested the ${documentType}. ${hubSentence}`;
};
